import * as query from "@arcgis/core/rest/query";
import * as urlUtils from "@arcgis/core/core/urlUtils.js";
import Query from "@arcgis/core/rest/support/Query";
import Extent from "@arcgis/core/geometry/Extent";
import MapImageLayer  from "@arcgis/core/layers/MapImageLayer";

export default {
  data() {
      return {

        
          // url_area_projek: "https://mygems.alami.my/server/rest/services/MakmalGeosains",  //Alami Punya
          url_area_projek: "https://mygems.jmg.gov.my/server/rest/services/MakmalGeosains",  //JMG Punya


          // url_area_projek: "https://mygems.jmg.gov.my/server/rest/services/MakmalGeosains",
          
          // url_area_projek: "https://gis.serasi.tech/arcgis/rest/services/MYGEMS/DataMakmal/MapServer",
          // url_area_projek: "https://mygems-gisweb.jmgdc.jmg.gov.my/server/rest/services/MakmalGeosains/DataMakmal/FeatureServer/2",



      }
  },    
  mounted(){
      this.checkingHost();
  },
  methods: {

    checkingHost(){

      // if(location.host.includes('alami')){
      //   this.url_area_projek = "https://mygems.alami.my/server/rest/services/MakmalGeosains"
      // }
      // else if(location.host.includes('jmg')){
      //   this.url_area_projek = "https://mygems.jmg.gov.my/server/rest/services/MakmalGeosains"
      // }



      urlUtils.addProxyRule({
        urlPrefix: this.url_area_projek,
        // proxyUrl: "https://mygems.jmg.gov.my/proxy/proxy.ashx?"
        // proxyUrl: "https://mygems.alami.my/proxy/proxy.ashx?"
        proxyUrl: "https://mygems.jmg.gov.my/proxy/proxy.ashx?"
      });

      // urlUtils.addProxyRule({
      //   urlPrefix: this.urlPortalSumberMineral,
      //   proxyUrl: "https://mygems.alami.my/proxy/proxy.ashx?"
      // });

      // this.dataLayerMap = new MapImageLayer({
      //   id: "data-makmal-geosains",
      //   title: "Projek Area",
      //   url: this.url_area_projek,
      // });

      
      // console.log(urlUtils);

    }

  },
  computed: {

  },
}